import { useQuery } from '@tanstack/vue-query';
import { useGmApi } from '@/composables/useGmApi';
import type { UseQueryOptions } from '@/types/query';
import type { ApiMe } from '@/types/users';
import { makeMeQueryKey } from '@/utils/queries';

type UseMeQueryOptions<T> = UseQueryOptions<ApiMe, T, null>;

export function useMeQuery<T = ApiMe>(
  queryOptions: UseMeQueryOptions<T> = {},
) {
  const { getMe } = useGmApi();

  const queryKey = makeMeQueryKey();

  const query = useQuery({
    staleTime: Infinity, // Never stale query by default
    retry: false,
    ...queryOptions,
    queryKey,
    queryFn: getMe,
    meta: {
      errorToast: {
        disabled: true, // Disable toast - errors are handled manually by logging out
      },
    },
    select: (me) => {
      return {
        ...me,
        teams: [...me.teams].sort((a, b) => a.name.localeCompare(b.name)),
      };
    },
  });

  return query;
}
